import { CarRef } from '../models/car'

export const mockCarRef = {
  id: 1,
  brand: 'Lexus',
  model: 'RZ 450e',
  year: 2023,
} as CarRef
